import styled from '@emotion/styled'
import React, { createContext, memo } from 'react'

import { Bottom } from './Bottom'
import { Contacts } from './Contacts'
import { Props as MenuItemProps } from './MenuItem'
import { Props as PolicyMenuItemProps } from './PolicyMenuItem'

export interface Props {
  address?: string
  administrationAddress?: string
  administrationEmail?: string
  administrationPhone?: string
  businessName?: string
  cin?: string
  email?: string
  facebookURL?: string
  instagramURL?: string
  languageCode: string
  legalRepresentative?: string
  menuItems: { [key: string]: MenuItemProps[] }[]
  pec?: string
  phone?: string
  phone2?: string
  phone3?: string
  phone4?: string
  policyMenu?: { [key: string]: PolicyMenuItemProps[] }[]
  rea?: string
  shareCapital?: string
  vat?: string
}

export const FooterContext = createContext({})

export const Footer = memo(function Footer({
  address,
  administrationAddress,
  administrationEmail,
  administrationPhone,
  businessName,
  cin,
  email,
  facebookURL,
  instagramURL,
  languageCode,
  legalRepresentative,
  menuItems,
  pec,
  phone,
  phone2,
  phone3,
  phone4,
  policyMenu,
  rea,
  shareCapital,
  vat,
}: Props) {
  return (
    <FooterContext.Provider
      value={{
        address,
        administrationAddress,
        administrationEmail,
        administrationPhone,
        businessName,
        cin,
        email,
        facebookURL,
        instagramURL,
        languageCode,
        legalRepresentative,
        menuItems,
        pec,
        phone,
        phone2,
        phone3,
        phone4,
        policyMenu,
        rea,
        shareCapital,
        vat,
      }}
    >
      <Container>
        <Contacts />

        <Bottom />
      </Container>
    </FooterContext.Provider>
  )
})

const Container = styled.footer`
  background: ${({ theme }) => theme.colors.variants.primaryLight};
`
